/* eslint-disable react/no-danger */
import React, { Component } from 'react';
import Modal from 'react-modal';
import axios from 'axios';

class SureFitModal extends Component {
  constructor(props) {
    super(props);
    const {
      globalConfig: { prismicApi },
    } = window;
    this.prismicApi = prismicApi;

    this.state = {
      html: '',
    };
  }

  componentDidMount() {
    let output = '';

    axios
      .get(this.prismicApi)
      .then((res) => {
        const { ref } = res.data.refs[0];
        return axios.get(`${this.prismicApi}/documents/search`, {
          params: {
            q: '[[at(my.contentpage.uid, "surefit-guarantee-to-fit")]]',
            ref,
          },
        });
      })
      .then((res) => {
        const surefitObj = res.data;
        surefitObj.results[0].data.body[0].items[0].article.forEach((obj, index) => {
          if (obj.type === 'paragraph') {
            output += `<p class="f6 f7-ns mb3 lh-copy">${obj.text}</p>`;
          } else if (obj.type === 'list-item') {
            if (surefitObj.results[0].data.body[0].items[0].article[index - 1].type !== 'list-item') {
              output += '<ul class="f6 f7-ns ml4 mb3">';
            }
            output += `<li class="mb2 lh-copy">${obj.text}</li>`;
            if (
              surefitObj.results[0].data.body[0].items[0].article[index + 1] &&
              surefitObj.results[0].data.body[0].items[0].article[index + 1].type !== 'list-item'
            ) {
              output += '</ul>';
            }
          }
        });
        const surefitContent = `
          <div class="cf">
            <div class="fl w-100 w-20-ns pt3 pv0-ns">
              <div class="f1 w4 mb3 center"
                style="background-image: url(/Content/images/Blinds.com/sprites-svg.svg);
                background-position: -74em -36em;
                background-repeat: no-repeat;
                background-size: 82.28571428571429em 43.857142857142854em;
                height: 86px;"></div>
              <h2 class="f4 f6-ns mt2 tc lh-title">${surefitObj.results[0].data.page_h1[0].text}</h2>
            </div>
            <div class="fl w-100 w-80-ns pl4-ns">
              <h3 class="mb3 tc tl-ns lh-title f5">${surefitObj.results[0].data.hero_h2_subtitle[0].text}</h3>
              ${output}
            </div>
          </div>
        `;
        this.setState({ html: surefitContent });
      })
      // eslint-disable-next-line no-console
      .catch((error) => console.log('SureFit Modal Error:', error));
  }

  render() {
    const { html } = this.state;
    return (
      <div className="pa3 flex-auto overflow-y-auto">
        <div dangerouslySetInnerHTML={{ __html: html }} />
      </div>
    );
  }
}

Modal.setAppElement('body');

export default SureFitModal;
